import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Collapse,
  Box,
  Chip,
  Grid,
  Button,
  TextField,
  MenuItem,
  Stack,
} from "@mui/material";
import {
  ExpandMore,
  TrendingUp,
  TrendingDown,
  TrendingFlat,
  HelpOutline,
  Flag,
  FiberManualRecord,
} from "@mui/icons-material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import LoadingScreen from "components/Loading";
import { getMyScorecard } from "services/api";
import { useAuth } from "context/authContext";
import { updateApprovementStatus } from "services/api";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import { getEmployee } from "services/api";
import { useLocation } from "react-router-dom";
import GaugeChart from "react-gauge-chart";
import ScorecardView from "./components/ScorecardView";
import MDBox from "components/MDBox";
import KPIHistoryChart from "./components/KPIHistoryView";
import WeighedHistoryChart from "./components/WeighedHistoryView";
import { useTranslation } from "react-i18next";
import KpiLinks from "./components/KpiLinks";
import { buttonStyles } from "services/utils";

const MyScorecard = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const employeeId = location.state?.employeeId;
  const isAdminView = location.state?.isAdminView || false;
  const [loading, setLoading] = useState(true);
  const [emp, setEmp] = useState(null);

  const { employee } = useAuth();

  const [view, setView] = useState(0);
  const [isCeo, setIsCeo] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!loading) setLoading(true);
      const empRole = employee.role;
      if (empRole === 1) setIsCeo(true);
      if (location.pathname === "/team/scorecard") {
        if (!emp) {
          const newemployee = await getEmployee(employeeId);
          setEmp(newemployee);
        }
      } else {
        setEmp(null);
      }
    };

    fetchData().then((e) => {
      setLoading(false);
    });
  }, [location]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <MDBox>
      <MDBox>
        <Stack
          direction={{ xs: "column", sm: "row" }} // Stack vertically on small screens
          spacing={1}
          alignItems="center" // Center buttons when stacked
        >
          <Button
            sx={{ ...buttonStyles(view === 0), width: { xs: "100%", sm: "auto" } }}
            variant={view === 0 ? "contained" : "outlined"}
            onClick={() => setView(0)}
          >
            {t("user.myScorecard.kpis")}
          </Button>

          {isCeo && !employeeId && (
            <Button
              sx={{ ...buttonStyles(view === 1), width: { xs: "100%", sm: "auto" } }}
              variant={view === 1 ? "contained" : "outlined"}
              onClick={() => setView(1)}
            >
              {t("user.myScorecard.kpiLinks")}
            </Button>
          )}

          <Button
            sx={{ ...buttonStyles(view === 2), width: { xs: "100%", sm: "auto" } }}
            variant={view === 2 ? "contained" : "outlined"}
            onClick={() => setView(2)}
          >
            {t("user.myScorecard.kpiHistory")}
          </Button>
        </Stack>
      </MDBox>
      {view == 0 ? (
        <ScorecardView
          employee={emp ? emp : employee}
          isMe={emp ? false : true}
          isAdminView={isAdminView}
        />
      ) : view == 1 ? (
        <KpiLinks></KpiLinks>
      ) : (
        <KPIHistoryChart employee={emp ? emp : employee} isMe={emp ? false : true} />
      )}
    </MDBox>
  );
};

export default MyScorecard;
